import React, { FunctionComponent } from "react";
import LaunchIcon from '@material-ui/icons/Launch';
import { Box, Button } from "@material-ui/core";

type Property = {
  href: string;
}

export const ExternalLinkButton: FunctionComponent<Property> = (props) =>(
  <Box my={2}>
    <Button href={props.href} endIcon={<LaunchIcon />} color="primary" variant="contained">
      {props.children}
    </Button>
  </Box>
);